
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PromotionSection: React.FC = () => {
  return (
    <section className="bg-earth-100 py-16 mt-16">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-4">Know another eco-friendly business?</h2>
          <p className="text-lg text-muted-foreground mb-8">
            Help our community grow by adding sustainable businesses to our database.
          </p>
          <Link to="/submit">
            <Button className="bg-eco-500 hover:bg-eco-600">
              Add a Listing
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PromotionSection;
